import { ChevronLeftIcon, ChevronRightIcon, XMarkIcon } from '@heroicons/react/20/solid'
import dayjs from 'dayjs'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Select from "react-select"
import { Postdata } from '../../../helpers/api.service'
import HttpService from '../../../helpers/httpServices'
import { message } from '../../../redux/actions/toastActions'
import { isPermission, isRole } from '../../../redux/selectors/authSelector'
import { useCountryNavigate } from '../../common/UseCountryNavigate'

function generateMonthDays(year, month, events) {
  const startDate = dayjs(`${year}-${month}-01`)
  const startOfMonth = startDate.startOf('month')
  const endOfMonth = startDate.endOf('month')
  const startDay = startOfMonth.day() === 0 ? 6 : startOfMonth.day() - 1
  const totalDays = endOfMonth.date()

  const days = []
  for (let i = 0; i < startDay; i++) {
    const date = startOfMonth.subtract(startDay - i, 'day').format('YYYY-MM-DD')
    days.push({ date, isCurrentMonth: false, events: events[date] || [] })
  }

  for (let i = 1; i <= totalDays; i++) {
    const date = dayjs(`${year}-${month}-${i}`).format('YYYY-MM-DD')
    days.push({
      date,
      isCurrentMonth: true,
      isToday: dayjs().isSame(date, 'day'),
      events: events[date] || [],
    })
  }

  const remaining = 42 - days.length
  const lastDate = dayjs(`${year}-${month}-${totalDays}`)
  for (let i = 1; i <= remaining; i++) {
    const date = lastDate.add(i, 'day').format('YYYY-MM-DD')
    days.push({ date, isCurrentMonth: false, events: events[date] || [] })
  }

  return days
}

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function CalendarComponent({ currentDate }) {
  const [currentMonth, setCurrentMonth] = useState(dayjs())
  const [modalOpen, setModalOpen] = useState(false)
  const [showColorPicker, setShowColorPicker] = useState(false)
  const [editingIndex, setEditingIndex] = useState(null)
  const [editingDate, setEditingDate] = useState(null)
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    id: null,
    title: '',
    date: '',
    place: '',
    start_time: '',
    end_time: '',
    members: [],
    board_members: [],
    notes: '',
    color: '#facc15',
  });
  const [refresh, setRefresh] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [events, setEvents] = useState({});
  const [member, setMember] = useState([]);
  const [boardMember, setBoardMember] = useState([]);
  const navigate = useCountryNavigate();
  const mode = localStorage.getItem("mode");
  const [days, setDays] = useState(generateMonthDays(currentMonth.year(), currentMonth.format('MM'), events))
  const [hoveredEvent, setHoveredEvent] = useState(null);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0, alignLeft: false });
  const [selectedDay, setSelectedDay] = useState(null);
  const [dayEventsModalOpen, setDayEventsModalOpen] = useState(false);
  const permissions = useSelector(isPermission);
  const role = useSelector(isRole)
  console.log("permissions", permissions)
  const addPermission = role == "admin" || role == "schooladmin" || permissions && permissions?.includes('edit_Education') || false;
  const deletePermission = role == "admin" || role == "schooladmin" || permissions && permissions?.includes('delete_Education') || false;
  const schoolId = localStorage.getItem("activeSchoolId");


  useEffect(() => {
    const year = currentDate.year();
    const month = currentDate.format('MM');
    const generatedDays = generateMonthDays(year, month, events);
    setDays(generatedDays);
  }, [currentDate, events]);



  const goToPreviousMonth = () => {
    setCurrentMonth(currentMonth.subtract(1, 'month'))
  }

  const goToNextMonth = () => {
    setCurrentMonth(currentMonth.add(1, 'month'))
  }

  const goToToday = () => {
    setCurrentMonth(dayjs())
  }

  const handleSaveEvent = () => {
    // const updatedEvents = { ...events }

    // const dateKey = formData.date
    // if (!updatedEvents[dateKey]) updatedEvents[dateKey] = []

    // if (editingIndex !== null && editingDate !== null) {
    //   // If editing an existing event
    //   updatedEvents[editingDate][editingIndex] = formData
    // } else {
    //   updatedEvents[dateKey].push(formData)
    // }

    // localStorage.setItem('calendarEvents', JSON.stringify(updatedEvents))
    // setEvents(updatedEvents)
    // setModalOpen(false)
    // setEditingIndex(null)
    // setEditingDate(null)
    if (isLoading) return;
    if (
      dayjs(`${formData.date}T${formData.end_time}`).isBefore(
        dayjs(`${formData.date}T${formData.start_time}`)
      )
    ) {
      dispatch(message('End time should be greater than Start time'));
      return; // stop submitting
    }

    const payload = {
      title: formData.title,
      place: formData.place,
      notes: formData.notes,
      date: formData.date,
      start_time: formData.start_time,
      end_time: formData.end_time,
      members: Array.isArray(formData.members) ? formData.members : [],
      board_members: Array.isArray(formData.board_members) ? formData.board_members : [],
      color: formData.color,
      school_id: schoolId,
    };
    if (formData.id) {
      payload.id = formData.id
    }
    console.log("payload.id>>>>>>>>>>>", payload.id)

    setIsLoading(true)
    Postdata(HttpService.calendar_event_add, payload).then((response) => {
      if (response.status === 200) {

        const savedEvent = {
          ...response.data,
          _start: dayjs(`${dayjs(response.data.date).format("YYYY-MM-DD")}T${response.data.start_time}`),
          _end: dayjs(`${dayjs(response.data.date).format("YYYY-MM-DD")}T${response.data.end_time}`),
        };

        const dateKey = dayjs(savedEvent.date).format("YYYY-MM-DD");

        setEvents(prev => ({
          ...prev,
          [dateKey]: prev[dateKey] ? [...prev[dateKey], savedEvent] : [savedEvent],
        }));
        setRefresh(!refresh)
        setModalOpen(false);
        setEditingIndex(null);
        setEditingDate(null);
        if (role === "admin" || role === "subadmin") {
          if (mode === "view") {
            navigate(`admin-school/view/${schoolId}`, {
              state: { mainTab: "Education" },
            });
          } else {
            navigate("navigation-dashboard", {
              state: { mainTab: "Education" },
            });
          }
        } else {
          navigate("education");
        }

      }
      /*  else {
        dispatch(message(response.message));
      } */
    })
      .finally(() => {
        // ✅ ensure loading resets
        setIsLoading(false);
      });

  }

  const openEditModal = (event, date, index) => {
    setFormData({ ...event, id: event._id })
    setEditingIndex(index)
    setEditingDate(date)
    setModalOpen(true)
    setShowColorPicker(false)
  }

  const fetchBoardMember = () => {
    setIsLoading(true)
    Postdata(HttpService.board_management_list, { school_id: schoolId }).then((response) => {
      if (response.status === 200) {
        setBoardMember(response.data.boards)
        setIsLoading(false)
      } else {
        setIsLoading(false)
        dispatch(message(response.message))
      }
    })
  }
  const fetchMembers = () => {
    setIsLoading(true)
    Postdata(HttpService.school_management_list, { school_id: schoolId, }).then((response) => {
      if (response.status === 200) {
        setMember(response.data.managers)
        setIsLoading(false)
      } else {
        setIsLoading(false)
        dispatch(message(response.message))
      }
    })
  }


  const handleBoardMemberChange = (selected) => {
    const selectedNames = selected ? selected.map((item) => item.value) : [];
    setFormData({ ...formData, board_members: selectedNames });
  }

  const handleMemberChange = (selected) => {
    const selectedNames = selected ? selected.map((item) => item.value) : [];
    setFormData({ ...formData, members: selectedNames });
  }


  const fetchEvents = () => {
    setIsLoading(true)
    Postdata(HttpService.calendar_event_list, { school_id: schoolId }).then((response) => {
      if (response.status === 200) {
        const grouped = {};
        response.data.forEach(event => {
          const dateKey = dayjs(event.date).format("YYYY-MM-DD");
          if (!grouped[dateKey]) grouped[dateKey] = [];
          grouped[dateKey].push({
            ...event,
            _start: dayjs(`${dateKey}T${event.start_time}`),
            _end: dayjs(`${dateKey}T${event.end_time}`),
          });
        });
        console.log("grouped>>>>>>>>>>", grouped)
        setEvents(grouped);
        setIsLoading(false)
      } else {
        setIsLoading(false)
        dispatch(message(response.message))
      }
    })
  }

  const handleDelete = (id) => {
    setIsLoading(true)
    Postdata(HttpService.calendar_event_delete, { id, school_id: schoolId }).then((response) => {
      setRefresh(!refresh)
      dispatch(message(response.message))

    })
    setHoveredEvent(null)
  }

  useEffect(() => {
    fetchEvents()
  }, [refresh]);
  useEffect(() => {
    fetchEvents()
    fetchMembers()
    fetchBoardMember()
  }, [])

  return (
    <div className="lg:flex lg:h-full lg:flex-col">
      {/* <header className="flex items-center justify-between border-b border-gray-200 px-6 py-4 lg:flex-none">
        <h1 className="text-base font-semibold leading-6 text-gray-900">
          {currentMonth.format('MMMM YYYY')}
        </h1>
        <div className="flex items-center">
          <div className="relative flex items-center rounded-md bg-white shadow-sm">
            <button onClick={goToPreviousMonth} className="h-9 w-12 rounded-l-md border border-gray-300 text-gray-400 hover:bg-gray-100">
              <ChevronLeftIcon className="h-5 w-5" />
            </button>
            <button onClick={goToToday} className="hidden md:block border-y border-gray-300 px-3.5 text-sm font-semibold text-indigo-600 hover:bg-indigo-100">
              Today
            </button>
            <button onClick={goToNextMonth} className="h-9 w-12 rounded-r-md border border-gray-300 text-gray-400 hover:bg-gray-100">
              <ChevronRightIcon className="h-5 w-5" />
            </button>
          </div>
        </div>
      </header> */}

      <div className="shadow ring-1 ring-black ring-opacity-5 lg:flex lg:flex-auto lg:flex-col">
        <div className="grid grid-cols-7 gap-px border-b border-gray-300 bg-gray-200 text-center text-xs font-semibold text-gray-700">
          {["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].map((day) => (
            <div key={day} className="bg-white py-2">{day}</div>
          ))}
        </div>

        <div className="hidden w-full lg:grid lg:grid-cols-7 lg:grid-rows-6 lg:gap-px">
          {days.map((day) => (
            <div
              key={day.date}
              onClick={() => {
                setFormData({
                  title: '',
                  date: day.date,
                  place: '',
                  time: '',
                  members: '',
                  notes: '',
                  color: '#facc15',
                })
                setModalOpen(true)
                setShowColorPicker(false)
                setEditingIndex(null)
                setEditingDate(null)
              }}
              className={classNames(
                'group relative aspect-square cursor-pointer p-2 transition duration-200 ease-in-out',
                day.isCurrentMonth ? 'bg-white' : 'bg-gray-100 text-gray-400',
                'hover:z-10 hover:shadow-md hover:bg-indigo-50'
              )}
            >
              <time
                dateTime={day.date}
                className={classNames(
                  'flex h-7 w-7 items-center justify-center rounded-full text-sm font-semibold',
                  day.isToday ? 'bg-indigo-100 text-indigo-600 ring-2 ring-indigo-400 ring-offset-2' : ''
                )}
              >
                {day.date.split('-').pop().replace(/^0/, '')}
              </time>

              {day.events.length > 0 && (
                <ol className="mt-1 space-y-1 ">
                  {day.events.slice(0, 2).map((event, idx) => (
                    <li
                      key={idx}
                      className="relative flex items-center justify-between text-xs px-1 py-0.5 rounded group"
                      style={{ backgroundColor: event.color || '#4f46e5' }}
                    >
                      <span className="truncate text-white">{event.title}</span>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          const rect = e.currentTarget.getBoundingClientRect();
                          const tooltipWidth = 260;
                          const alignLeft = rect.left + tooltipWidth > window.innerWidth;
                          setTooltipPosition({
                            x: rect.left,
                            y: rect.top + window.scrollY,
                            alignLeft
                          });
                          setHoveredEvent(event);
                        }}
                        className="ml-1 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                      >
                        👁️
                      </button>

                    </li>
                  ))}
                  {day.events.length > 2 && (
                    <li
                      className="text-xs text-gray-500 cursor-pointer hover:underline mt-1"
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedDay(day); // You will add this state
                        setDayEventsModalOpen(true); // You will add this state
                      }}
                    >
                      + {day.events.length - 2} more
                    </li>
                  )}
                </ol>
              )}
            </div>
          ))}
        </div>
      </div>
      {hoveredEvent && (
        <div
          className="absolute z-50 bg-white rounded-md shadow-lg p-3 text-sm border w-64"
          style={{
            top: tooltipPosition.y + 10,
            left: tooltipPosition.alignLeft
              ? tooltipPosition.x - 270
              : tooltipPosition.x + 10
          }}
        // onMouseLeave={() => setHoveredEvent(null)}
        >
          <div className="flex justify-end">
            <button
              onClick={() => setHoveredEvent(null)}
              className="p-1 rounded hover:bg-gray-100"
              aria-label="Close tooltip"
            >
              <XMarkIcon className="h-5 w-5 text-gray-400 hover:text-gray-600" />
            </button>
          </div>
          <h4 className="font-semibold text-gray-800 mb-1">{hoveredEvent.title}</h4>
          <p className="text-xs text-gray-600 mb-1">
            {dayjs(`${hoveredEvent.date}T${hoveredEvent.start_time}`).format('dddd, MMM D')}<br />
            {dayjs(`${hoveredEvent.date}T${hoveredEvent.start_time}`).format('h:mm A')} – {dayjs(`${hoveredEvent.date}T${hoveredEvent.end_time}`).format('h:mm A')}
          </p>
          {hoveredEvent.place && <p><strong>Place:</strong> {hoveredEvent.place}</p>}
          {hoveredEvent.members && hoveredEvent.members.length > 0 && (
            <p>
              <strong>Members:</strong>{" "}
              {member
                .filter(m => hoveredEvent.members.includes(m._id))
                .map(m => m.name)
                .join(", ")}
            </p>
          )}
          {hoveredEvent.board_members && hoveredEvent.board_members.length > 0 && (
            <p>
              <strong>Board Members:</strong>{" "}
              {boardMember
                .filter(b => hoveredEvent.board_members.includes(b._id))
                .map(b => b.name)
                .join(", ")}
            </p>
          )}
          {hoveredEvent.notes && <p><strong>Notes:</strong> {hoveredEvent.notes}</p>}
          <div className="mt-3 flex gap-2 justify-end">
            {addPermission && <button
              className="text-xs text-indigo-600 hover:underline"
              onClick={() => {
                openEditModal(hoveredEvent, hoveredEvent.date, hoveredEvent._index || 0);
                setHoveredEvent(null);
              }}
            >
              Edit
            </button>}
            {deletePermission && <button
              className="text-xs text-red-600 hover:underline"
              onClick={() => handleDelete(hoveredEvent._id)}>
              Delete
            </button>}
          </div>
        </div>
      )}
      {/* Day All events modal */}
      {dayEventsModalOpen && selectedDay && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-[1px]">
          <div className="bg-white rounded-2xl shadow-2xl p-6 w-full max-w-md max-h-[80vh] overflow-y-auto relative">
            <button
              onClick={() => setDayEventsModalOpen(false)}
              className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
              aria-label="Close"
            >
              <XMarkIcon className="h-6 w-6" />
            </button>

            <h2 className="text-xl font-semibold mb-4 text-gray-800 text-center">
              Events on {dayjs(selectedDay.date).format('MMMM D, YYYY')}
            </h2>

            {selectedDay.events.length === 0 ? (
              <p className="text-center text-gray-500">No events for this day.</p>
            ) : (
              <ul className="space-y-4">
                {selectedDay.events.map((event, idx) => (
                  <li
                    key={idx}
                    className="border border-gray-200 rounded-lg p-4 shadow-sm hover:shadow transition-shadow bg-gray-50"
                  >
                    <div className="flex justify-between items-start">
                      <div className="space-y-1">
                        <p className="text-base font-semibold text-gray-800">{event.title}</p>
                        <p className="text-xs text-gray-600">
                          {dayjs(`${event.date}T${event.start_time}`).format('dddd, MMM D')}
                        </p>
                        <p className="text-xs text-gray-600">
                          {dayjs(`${event.date}T${event.start_time}`).format('h:mm A')} – {dayjs(`${event.date}T${event.end_time}`).format('h:mm A')}
                        </p>
                        {event.place && (
                          <p className="text-xs text-gray-700">
                            📍 <span className="font-medium">{event.place}</span>
                          </p>
                        )}
                        {event.members && event.members.length > 0 && (
                          <p className="text-xs text-gray-700">
                            👥 <span className="font-medium">Members:</span>{" "}
                            {member
                              .filter(m => event.members.includes(m._id))
                              .map(m => m.name)
                              .join(", ")}
                          </p>
                        )}
                        {event.board_members && event.board_members.length > 0 && (
                          <p className="text-xs text-gray-700">
                            🪑 <span className="font-medium">Board:</span>{" "}
                            {boardMember
                              .filter(b => event.board_members.includes(b._id))
                              .map(b => b.name)
                              .join(", ")}
                          </p>
                        )}
                        {event.notes && (
                          <p className="text-xs text-gray-700">
                            📝 <span className="font-medium">Notes:</span> {event.notes}
                          </p>
                        )}
                      </div>

                      <div className="flex gap-5 items-end space-y-1">
                        {addPermission && <button
                          className="text-xs text-indigo-600 hover:underline"
                          onClick={() => {
                            openEditModal(event, event.date, event._index || 0);
                            setDayEventsModalOpen(false);
                          }}
                        >
                          Edit
                        </button>}
                        {deletePermission && <button
                          className="text-xs text-red-600 hover:underline"
                          onClick={() => handleDelete(event._id)}
                        >
                          Delete
                        </button>}
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      )}


      {modalOpen && addPermission && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-25">
          <div className="bg-white rounded-2xl shadow-xl p-6 w-full max-w-md space-y-4">
            <div className="flex justify-between items-center">
              <input
                type="text"
                placeholder="Event Title"
                className="text-lg font-semibold w-full outline-none"
                value={formData.title}
                onChange={(e) => setFormData({ ...formData, title: e.target.value })}
              />
              <div className="relative ml-3">
                <button
                  className="w-10 h-6 flex items-center justify-center rounded-full border bg-white shadow"
                  onClick={() => setShowColorPicker(!showColorPicker)}
                >
                  <span className="w-3 h-3 rounded-full" style={{ backgroundColor: formData.color }} />
                </button>
                {showColorPicker && (
                  <div className="absolute right-0 mt-2 bg-white p-2 rounded shadow grid gap-2 z-10">
                    {['#f87171', '#facc15', '#4ade80', '#60a5fa', '#a78bfa', '#f472b6'].map((color) => (
                      <button
                        key={color}
                        onClick={() => {
                          setFormData({ ...formData, color })
                          setShowColorPicker(false)
                        }}
                        className="w-5 h-5 rounded-full"
                        style={{ backgroundColor: color }}
                      />
                    ))}
                  </div>
                )}
              </div>
            </div>

            <div className="grid grid-cols-2 gap-3">
              <input
                type="date"
                className="w-full border rounded px-3 py-2 outline-none"
                value={formData.date}
                onChange={(e) => setFormData({ ...formData, date: e.target.value })}
              />
              <input
                type="time"
                className="w-full border rounded px-3 py-2 outline-none"
                value={formData.start_time}
                placeholder='Start Time'
                onChange={(e) => setFormData({ ...formData, start_time: e.target.value })}
              />
              <input
                type="time"
                className="w-full border rounded px-3 py-2 outline-none"
                value={formData.end_time}
                placeholder='End Time'
                onChange={(e) => setFormData({ ...formData, end_time: e.target.value })}
              />
            </div>

            <input
              type="text"
              placeholder="Place"
              className="w-full border rounded px-3 py-2 outline-none"
              value={formData.place}
              onChange={(e) => setFormData({ ...formData, place: e.target.value })}
            />

            <Select
              isMulti
              name="members"
              placeholder="School Members"
              options={member.map((m) => ({ value: m._id, label: m.name }))}
              value={formData.members && formData.members.map((id) => ({
                value: id,
                label: member.find((m) => m._id === id).name
              }))}
              onChange={handleMemberChange}
            />

            <Select
              isMulti
              name="board members"
              placeholder="Board Members"
              options={boardMember.map((m) => ({ value: m._id, label: m.name }))}
              value={formData.board_members && formData.board_members.map((id) => ({
                value: id,
                label: boardMember.find((m) => m._id === id).name
              }))}
              onChange={handleBoardMemberChange}
            />

            <textarea
              placeholder="Notes"
              className="w-full border rounded px-3 py-2 outline-none"
              rows={2}
              value={formData.notes}
              onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
            />

            <div className="flex justify-end space-x-2 pt-2">
              <button
                onClick={() => setModalOpen(false)}
                className="px-4 py-2 rounded bg-gray-100 hover:bg-gray-200"
              >
                Cancel
              </button>
              <button
                onClick={handleSaveEvent}
                disabled={isLoading}
                className={`px-4 py-2 rounded text-white transition ${isLoading
                    ? "bg-indigo-400 cursor-not-allowed"
                    : "bg-indigo-600 hover:bg-indigo-700"
                  }`}
              >
                {isLoading
                  ? "Saving..."
                  : editingIndex !== null
                    ? "Update"
                    : "Save"}
              </button>
            </div>
          </div>
        </div>

      )}
    </div>
  )
}
